const DuckMoves = [
    {
        frame: 1,
        position: {
            x: 0,
            y: 0,
            z: 0
        },
        rotation: {
            x: 0,
            y: 0.8,
            z: 0
        },
        accessory: false
    },
    {
        frame: 46,
        position: {
            x: 4,
            y: 0,
            z: 4
        },
        rotation: {
            x: 0,
            y: 0.8,
            z: 0
        },
        accessory: true
    },
    {
        frame: 47,
        position: {
            x: 6,
            y: 0,
            z: 2
        },
        rotation: {
            x: 0,
            y: -Math.PI / 2,
            z: 0
        },
        accessory: true
    },
    {
        frame: 65,
        position: {
            x: 1,
            y: 0,
            z: 2
        },
        rotation: {
            x: 0,
            y: -Math.PI / 2,
            z: 0
        },
        accessory: true
    },
    {
        frame: 95,
        position: {
            x: -2,
            y: 0,
            z: 2
        },
        rotation: {
            x: 0,
            y: -Math.PI/2,
            z: 0
        },
        accessory: true
    },
    {
        frame: 99,
        position: {
            x: -5,
            y: 0,
            z: 2
        },
        rotation: {
            x: 0,
            y: -Math.PI/3,
            z: 0
        },
        accessory: true
    },
]

export default DuckMoves